import type { ComponentMeta } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { backgroundColor } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { color } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontSize } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/fontSize";
import { margin } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@/react/components/shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  ContentProp,
  DesignProp,
  FontProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@/react/components/shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Footer",
  version: 1,
  isHidden: true,
  nameI18n: "builder_ui.block_type.footer",
  category: [],
  props: {
    logo: {
      name: "Logo",
      nameI18n: "builder_ui.prop_type.add_logo",
      category: [ContentProp],
      prop: "other",
      type: "boolean",
      defaultValue: false,
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          type: "color-without-alpha",
          nameI18n:
            "settings.emails.visual_builder.prop_type.styles.background_color",
          defaultValue: defaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        },
        color: {
          ...color,
          type: "color-without-alpha",
          defaultValue: defaultStyles.content.color,
          category: [DesignProp, FontProp],
        },
        fontSize: {
          ...fontSize,
          defaultValue: defaultStyles.content.fontSize,
          category: [DesignProp, FontProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
